import React from "react";

const TaskDescriptionModal = ({ isVisible, message, onClose }) => {
  if (!isVisible) return null;
  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 "
      onClick={handleBackgroundClick}
    >
      <div className="bg-white rounded-lg w-1/3 shadow-lg relative shadow-red-700">
        <button
          className="absolute top-0 right-2 text-xl text-gray-500 hover:text-red-700"
          onClick={onClose}
        >
          &times;
        </button>
        <div className="text-red-800 text-lg p-4">{message}</div>
      </div>
    </div>
  );
};

export default TaskDescriptionModal;
